import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * The one OTP entry field (Login, VerifyPhone, PhoneGate). Shared behaviour, so it cannot drift:
 * - digits only, max 6 (a pasted "123 456" or an autofilled code lands clean);
 * - ANY edit calls `onEdit`, which callers use to clear a stale wrong-code error immediately
 *   rather than leaving it on screen until the next submit;
 * - select-all + delete (or a single Backspace on a selection) empties the field in one go - the
 *   value is fully controlled, nothing resists the clear.
 */
export function OtpInput({ id, testId, label, value, onChange, onEdit, onSubmit, error, errorTestId }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        data-testid={testId}
        value={value}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        onChange={(e) => {
          onChange(e.target.value.replace(/\D/g, "").slice(0, 6));
          if (onEdit) onEdit();
        }}
        onKeyDown={(e) => e.key === "Enter" && onSubmit && onSubmit()}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        className="font-mono text-2xl tracking-widest"
      />
      {error && (
        <p id={`${id}-error`} role="alert" data-testid={errorTestId} className="text-sm text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}
